import React, {useState, useEffect} from 'react';
import { Box, Button, Link, Typography, Stack, Tooltip } from '@mui/material';
import { StyledFlexEnd, StyledLeadContainer, StyledSubHeader,  } from '../../Components/Styled';
import { privateRoutesPath } from '../../Routes';
import { CreateLeadFooter } from '../../Components/Styled';
import DataGridTable from '../../Components/DataGrid';
import { useSnackbar } from 'notistack';
import BiztantuLoader from '../../Components/Loader';
import { useSelector, useDispatch } from 'react-redux';
import { createOrderRequestData, dateFormatting, getOrderRequestData, updateOrderRequestData } from '../../Utility/apiHelper';
import { requestShowLoader, requestHideLoader, requestShowDialogLoader, requestHideDialogLoader } from "../../Store/Global/action";
import LeadProduct from '../../Components/LeadProduct';
import { createFilterOptions } from '@mui/material';
import LeadDialog from '../../Components/LeadDialog';
import { GridActionsCellItem, GridRowModes } from '@mui/x-data-grid';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Close';
import { ACTIVE_STATUS, CHILD_DATAGRIDTABLE_HEIGHT, emailWidth, handleValidateCodevalue,  INVOICE_STATUS_OPEN,  PRODUCT_TYPE, ROWS_TO_VIEW_IN_CHILD_TABLE, SALES_ORDER_STATUS, salesOrderStatus, searchEntity } from '../../Utility/constant';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { EntityNote } from '../../Components/EntityNote';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import WhoColumnTextfieds from '../../Components/WhoColumnTextfieds';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import LeadAccordion from '../../Components/LeadAccordion';
import AuditLogs from '../Configuration/Audit';

import tableBodyicon from '../../Assets/images/tablebody_edit.png'
import tableEditicon from '../../Assets/images/tableheader_edit.png';
import disabledEdit from '../../Assets/images/disabled_edit.png';
import { requestGetAllCustomers } from '../../Store/Customer/action';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import { salesOrderInvoiceDialog } from '../../Utility/calculations';
import useNavigation from '../../Utility/hooks/useNavigation';
import './salesOrder.css';

const CreateEditSalesOrder = (props) => {
        const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);

    const [isRequired,setIsRequired] = useState(false)
    const location = useLocation();
    const SOStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == SALES_ORDER_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const from = location?.state?.from
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const OrderId = props.match.params.id;
    const canEdit = !!specificRolePermission?.isOrderManage;
    const [isEntityLocked, setIsEntityLocked] = useState(OrderId ? false : false);
    const isViewMode = !canEdit || isEntityLocked;
    // Audit Logs accordion — controlled so we can collapse it after actions; fetches lazily on expand
    const [isAuditAccordionExpanded, setIsAuditAccordionExpanded] = useState(false);
    const leadId = props.location.state;
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const [orderdetail, setorderdetail] = useState({
        status: "SO_STATUS_OPEN",
        invoiceProductDtos : [],
        salesOrderProducts : []
    });
    const [cloneorderdetails, setcloneorderdetails] = useState(null);
    const dispatch = useDispatch();
    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const [isDialogOpen, setOpenDialog] = useState({
            isOpen: false,
            isConfirm : false,
            dilaogproductdata: []
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [selectedproduct, setSelectedproduct] = useState(null);
    const [selectedproductData, setSelectedProductData] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [pricerange, setpricerange] = React.useState([0, 100000000]);
    var filterdOptionlist = [];
    const [inputprice, setInputprice] = useState({
        pricefromInput: 0,
        pricetoInput: 100000000
    })
    const [selectedaddedproduct, setselectedaddedproduct] = useState([]);
    const [productQuantity, setproductQuantity] = useState(null);
    const productStaticType = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    
    const ownerlist = useSelector(state => state?.owner?.ownerlist);
    const [ownerlistdropdown, setownerlistdropdown] = useState([]);
    const myTeam = useSelector(state => state?.owner?.Team);
    const { navigateTo,goBackTo } = useNavigation();
        useEffect(() => {
            const ownerlistdata = ((specificRolePermission?.isAllOrderManage ? ownerlist 
                : specificRolePermission?.isOrderTeamManage ? myTeam 
                : [{firstName: `${currentUser?.firstname}`,
                    lastName : `${currentUser?.lastname}`,
                    id: currentUser?.userId,
                }]) || [])?.map(item => {
                return {
                    name: `${item?.firstName} ${item?.lastName}`,
                    id: item?.id
                }
            })
            setownerlistdropdown(ownerlistdata);
        },[ownerlist,myTeam,currentUser])

        useEffect(()=>{
            if(!OrderId && ownerlistdropdown?.length>0){
            const filteredOwner = ownerlistdropdown?.find(item=> item?.id ===  currentUser?.userId)
            setorderdetail({
                ...orderdetail,
                selectedOwner : filteredOwner,
                ownerId: filteredOwner?.id
                        })
        }
        },[ownerlistdropdown])
    
 const handleViewInvoiceSlip = (id) => {
    navigateTo(`${privateRoutesPath.EDIT_INVOICE}/${id}`,{},searchEntity?.salesOrder);
  }
    useEffect(() => {
    dispatch(requestGetAllCustomers())
      }, [])



    const customerdropdown = useSelector(state=> state?.customer?.customer)

    const goBack = () => goBackTo(privateRoutesPath.ORDER, searchEntity.salesOrder);
 
    const orderInvoiceColumns = [
           { 
            field: 'invoiceId', 
            headerName: handleValidateCodevalue(internationalise,'SO_INV_ID'),
            flex: 1,
            editable: false,
                     renderCell: (params) => {
                      return (
                     <Link
                   component="button"
                   variant="body2"
                   onClick={() => handleViewInvoiceSlip(params?.value)}
                   >
                   {params?.value}
                     </Link>
                    );
                 }
               },
        { 
            field: 'productType', 
            headerName: handleValidateCodevalue(internationalise,'SO_INV_PROD_TYPE'),
            flex: 1,
            editable: false,
            valueGetter: ({ value }) => value ? handleValidateCodevalue(internationalise, value) : ''
        },
        { 
            field: 'productName', 
            headerName: handleValidateCodevalue(internationalise,'SO_INV_PROD_NAME'),
            flex: 1,
            editable: false,
        },
           { 
            field: 'invoiceQty', 
            headerName: handleValidateCodevalue(internationalise,'SO_INV_PROD_QTY'),
            flex: 1,
            editable: false 
        },
           { 
            field: 'grandTotal', 
            headerName: handleValidateCodevalue(internationalise,'SO_INV_PROD_TOTAL_PRICE'),
            flex: 1,
            editable: false 
        },
           { 
            field: 'updatedAt', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_UPDATED_AT'),
            flex: 1,
            editable: false 
        },
    ]


  

    const handleSelectMultiproduct = (event, productData, reason) => {
        if (productData.find(option => option.value === "select-all")) {
            setselectedaddedproduct([...selectedaddedproduct,...filterdOptionlist]);
        } else {
            setselectedaddedproduct(productData);
        }
    }

    const handleClearAfterAdded = () => {
        setselectedaddedproduct([]);
         
    }


    useEffect(() => {
        if(OrderId && ownerlistdropdown?.length>0) {
            getSpecificorderdetails();
        }
    },[OrderId,ownerlistdropdown])

    const reset = ()=>{
            setorderdetail([])
            setcloneorderdetails([]);
    }
    const getSpecificorderdetails = async() => {
        dispatch(requestShowLoader());
        const url = `${process.env.REACT_APP_ORDER_URL}sales-orders/${OrderId}`;
        const responseData = await getOrderRequestData(url);
        if(responseData?.status == 200) {
            dispatch(requestHideLoader());
            const orderProductdata = responseData?.data?.salesOrderProductDto?.map((item)=>{
                return {
                    ...item,
                    unitOfMeasurement : item?.uom,
                    type : item?.productType,
                    name : item?.productName,
                    orderId : item?.orderId,
                    productId : item?.productId,
                    price: item?.rate,
                    quantity: item?.orderQty,
                    invoicedqty: item?.invoiceQty ? item?.invoiceQty : 0 ,
                    remainingQty : item?.remainingQty,
                    grossprice: item?.totalPrice,
                    sellingPrice : item?.productPrice,
                    id: item?.id,
                    priceAfterDiscount : (item?.productPrice - (item?.productPrice * item?.primaryDiscount)/100)*item?.orderQty,
                    unitDiscountAmount : item?.productPrice- (item?.productPrice - (item?.productPrice * item?.primaryDiscount)/100)
                }
            })
            const orderInvoiceData = responseData?.data?.invoiceProductDtos?.map((item)=>{
                return {
                    id : item?.invoiceId,
                    ...item,
                    createdAt : dateFormatting(item?.createdAt),
                    updatedAt : dateFormatting(item?.updatedAt)
                }
            })
            const filteredCustomer = customerdropdown?.find(item=> item?.id === responseData?.data?.customerId)
            const filteredOwner = ownerlistdropdown?.find(item=> item?.id === responseData?.data?.ownerId)
            const updatedData = {
                ...responseData?.data,
                selectedOwner : filteredOwner,
                selectedCustomer : filteredCustomer,
                salesOrderProducts : orderProductdata,
                invoiceProductDtos : orderInvoiceData
            }
            setorderdetail(updatedData);
            setcloneorderdetails(updatedData);
            if (!(updatedData?.status === salesOrderStatus?.SO_STATUS_OPEN || updatedData?.status === salesOrderStatus?.SO_STATUS_PARTIALLY_INVOICED)) {
                setIsEntityLocked(true);
            }
        }
        else {
            dispatch(requestHideLoader());
            reset();
        }
    }

    const handleChangeQuantity = (e) => {
        setproductQuantity(e.target.value)
    }

    const handleAddOrderProduct = async() => {
        const payload = [];

        const productorderUrl = `${process.env.REACT_APP_ORDER_URL}sales-order-product`;

        selectedaddedproduct.map((item, index) => {
            payload.push({
                ...item,
                sGst: item?.sgstRate,
                cGst: item?.cgstRate,
                primaryDiscount: item?.primaryDiscount,
                surchargeRate: item?.surChangeRate,
                "productPrice": parseFloat(item?.price),
                "totalPrice": (1*item?.price),
                "productId": item?.id,
                "orderQty": 1,
                "orderId": parseInt(OrderId)
            })
        });

        dispatch(requestShowLoader());
        const orderproductresponse = await createOrderRequestData(payload, productorderUrl);
        dispatch(requestHideLoader());

        if (orderproductresponse?.status == 200) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_ADDED_SUCCESSFULLY'), {variant: 'success'});
            await getSpecificorderdetails();
            setIsAuditAccordionExpanded(false);
            handleClearAfterAdded();
            return true;
        } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_PLEASE_TRY_AGAIN'), {variant: 'error'});
            return false;
        }
    }
    
    const handleUpdateOrderproduct = async(orderproduct) => {
        const payload = {
            ...orderproduct,
            "id": orderproduct?.id,
            "orderId": orderproduct?.orderId,
            "productId": orderproduct?.productId,
            "orderQty": orderproduct?.quantity,
            "productQuantity": parseFloat(orderproduct?.quantity),
            "rate": orderproduct?.rate,
        }

        const productorderUrl = `${process.env.REACT_APP_ORDER_URL}sales-order-product`;


            dispatch(requestShowLoader());
        

            const orderproductresponse = await updateOrderRequestData(payload, productorderUrl);



            if(orderproductresponse?.status == 200) {

                await getSpecificorderdetails();

                setIsAuditAccordionExpanded(false);

                dispatch(requestHideLoader());

                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY "), {variant: 'success'});
            
            } else {

                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'});
                dispatch(requestHideLoader());
            
            }

            

            
    }   

    const filter = createFilterOptions();

    const handleFilterOption = (options, params) => {
        filterdOptionlist = filter(options, params);
        return [ { name: 'Select All', price: "", value: "select-all" }, ...filterdOptionlist];
   }

   const handlechangeInputprice = (event) => {
        setInputprice({
            ...inputprice,
            [event.target.name]: event.target.value
        })
    }

    const handleChnageOrderdetail = (event) => {
        setorderdetail({
            ...orderdetail,
            [event.target.name]: event.target.value
        })
    }

    const handleCreateOrder = async() => {
        if(!orderdetail?.ownerId || !orderdetail?.customerId){
            setIsRequired(true)
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS") , {variant:"error"})
            return;
        }
        dispatch(requestShowLoader());
        const reqOrderPayload = {
            "ownerId" : orderdetail?.ownerId,
            "status": orderdetail?.status,
            "customerId": orderdetail?.customerId,
            "note" : orderdetail?.note,
            "salesOrderProductDto": []
        }
            tableData.map((item, index) => {
                reqOrderPayload.salesOrderProductDto.push({
                    ...item,
                    sGst: item?.sgstRate,
                    cGst: item?.cgstRate,
                    primaryDiscount: item?.primaryDiscount,
                    surchargeRate: item?.surChangeRate,
                    "productPrice" : item?.sellingPrice,
                    "productId": item?.id,
                    "orderQty": parseFloat(item?.quantity),
                    "totalPrice" : item?.grossprice
                })
            });

       

        const orderUrl = `${process.env.REACT_APP_ORDER_URL}sales-orders`;

        const orderresponse = await createOrderRequestData(reqOrderPayload, orderUrl);

        if(orderresponse.status !== 200) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'});
           
        } else {

            // const orderId = orderresponse?.data?.id;
            // // /order-product"
            // const payload = [];

            // const productorderUrl = `${process.env.REACT_APP_ORDER_URL}order-product`;
            // tableData.map((item, index) => {
            //     payload.push({
            //         "rate": parseFloat(item?.price),
            //         "productId": item?.id,
            //         "productQuantity": parseFloat(item?.productQuantity),
            //         "orderId": orderId
            //     })
            // });


            // const orderproductresponse = await createOrderRequestData(payload, productorderUrl);
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_CREATED_SUCCESSFULLY"), {variant: 'success'});
            navigateTo(`${privateRoutesPath.VIEW_ORDER}/${orderresponse?.data?.id}`,{},searchEntity?.salesOrder);
        }
        
        dispatch(requestHideLoader());
    }

    const handleUpdateOrder = async(value = false) => {
        if(!orderdetail?.ownerId && !orderdetail?.customerId){
            setIsRequired(true)
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS") , {variant:"error"})
            return;
        }
        const url = `${process.env.REACT_APP_ORDER_URL}sales-orders`;
        const newproductdto = orderdetail?.salesOrderProducts?.map(item => {
            return {
                "rate": item?.price,
                "productId": item?.productId,
                "productQuantity": item?.productQuantity,
            }
        })
        if(JSON.stringify(orderdetail) == JSON.stringify(cloneorderdetails)){
            if(value === true){
                goBack();
            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"), {variant : 'info'});
            }
        }
        else{
        const newupdateRequestdata = {
            ...orderdetail,
            status: orderdetail?.status,
            orderId: parseInt(OrderId),
            orderProductDto: newproductdto
        }
        delete newupdateRequestdata['orderProducts'];

        const responseData = await updateOrderRequestData(newupdateRequestdata, url);

        if(responseData?.status !== 200 ) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'});
            
          } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY"), {variant: 'success'});
            await getSpecificorderdetails();
            setIsAuditAccordionExpanded(false);
            if(value === true){
            goBack();
          }
        }
        }
    }

    const handlecancelorder = () => {

    }


    const handlegenerateinvoice = () => {
        const dilaogproduct = orderdetail?.salesOrderProducts?.filter(item => selectionModel.includes(item?.id)).map(item => {
            const newData = salesOrderInvoiceDialog({...item,invoiceqty : item?.remainingQty,price : item?.sellingPrice})
            return {
                ...item,
                ...newData,
                price : item?.sellingPrice,
                invoiceqty: item?.remainingQty,
                subTotal : parseInt(item?.sellingPrice * item?.remainingQty)
            }
        });
        setOpenDialog({
            ...isDialogOpen,
            isOpen: true,
            dilaogproductdata: dilaogproduct
        })
    }

    const handlecreateinvoice = async() => {
        try{
        dispatch(requestShowDialogLoader());
        const url = `${process.env.REACT_APP_ORDER_URL}invoice`;
        const invoicedProduct = isDialogOpen?.dilaogproductdata;
        var totalamount = 0;
        var remarks = [];
        const pdfDocumentbody = {
            invoiceProduct: invoicedProduct,
            customerdeatils: customerdropdown.find(item => item?.id == orderdetail?.customerId),
            invoiceResponse: null
        }
        const invproductdto = invoicedProduct.map(item => {
            totalamount = parseFloat(totalamount) + parseFloat(parseFloat(item?.invoiceqty)*parseFloat(item?.price))
            remarks.push(item.productName)
            return {
                ...item,
                "rate": item?.price,
                "totalPrice" : parseFloat(parseFloat(item?.invoiceqty)*parseFloat(item?.price)),
                "productId": item?.productId,
                "invoiceQty": item?.invoiceqty
            }
        })
        const reqbody = {
            "ownerId" : orderdetail?.ownerId,
            "amount": parseFloat(totalamount),
            "createdBy": 0,
            "description": orderdetail?.description,
            "id": 0,
            "customerId": parseInt(orderdetail?.customerId),
            "orderId": OrderId,
            "invoiceProductDto": invproductdto,
            "remark": `${remarks.join("_")}-invoice`,
            "status": INVOICE_STATUS_OPEN,
            "taxPercent": "12",
            "updatedBy": 0
          }

          const responseData = await createOrderRequestData(reqbody, url);
          if(responseData?.status !== 200) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'});
          } else {
             setOpenDialog({
                ...isDialogOpen,
                isConfirm : false,
                isOpen: false,
                dilaogproductdata: [],
             })
             await getSpecificorderdetails();
             setIsAuditAccordionExpanded(false);
            enqueueSnackbar(handleValidateCodevalue(internationalise,"SO_INV_GENERATED_SUCCESSFULLY"), {variant: 'success'})
            setSelectionModel([]);
    
          }
        }
        catch{

        }
        finally {
            dispatch(requestHideDialogLoader());
        }

    }


    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };
    
    const handleSaveClick = (id) => () => {
      setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };

    const handleCancelClick = (id) => () => {
        setRowModesModel({
          ...rowModesModel,
          [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    
        const editedRow = isDialogOpen?.dilaogproductdata.find((row) => row.id === id);
        if (editedRow.isNew) {
            setOpenDialog({
                ...isDialogOpen,
                dilaogproductdata: isDialogOpen?.dilaogproductdata.filter((row) => row.id !== id),
            })
          
        }
      };


    const handleUpdateProduct = (newRecord) => {
  const newData = salesOrderInvoiceDialog(newRecord);
  const updatedRecord = {
    ...newRecord,
    grossprice: parseFloat(newRecord?.price || 0) * parseFloat(newRecord?.invoiceqty || 0),
    subTotal : parseFloat(newRecord?.price || 0) * parseFloat(newRecord?.invoiceqty || 0),
    ...newData,
    isNew: false
  };
  setOpenDialog(prev => ({
    ...prev,
    dilaogproductdata: prev.dilaogproductdata.map(row =>
      row.id === newRecord.id ? updatedRecord : row
    )
  }));
};

    const handleviewproductinvoices = (productId, orderId) => {
        navigateTo(`${privateRoutesPath.INVOICE}`, {productId, orderId },searchEntity?.salesOrder);
    }
    

    const handleAuditAccordionChange = (_, isExpanded) => {
        setIsAuditAccordionExpanded(isExpanded);
    };

    const invoiceGenerateColumns = [
        
 {
          field: 'actions',
          type: 'actions',
          headerName: <Tooltip title={handleValidateCodevalue(internationalise,'COMMON_ACTION')} ><img src={tableEditicon} className="sales-order-edit-icon" /></Tooltip>,
          width: 100,
          cellClassName: 'actions',
          getActions: ({ id }) => {
            const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
    
            if (isInEditMode) {
              return [
                <GridActionsCellItem
                  icon={<CheckIcon />}
                  label={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                  className="textPrimary"
                  onClick={handleSaveClick(id)}
                />,
                <GridActionsCellItem
                  icon={<CancelIcon />}
                  label={handleValidateCodevalue(internationalise,'COMMON_CANCEL')}
                  className="textPrimary"
                  onClick={handleCancelClick(id)}
                  color="inherit"
                />,
              ];
            }
    
            return [
              <GridActionsCellItem
                icon={<img src={(!specificRolePermission?.isOrderManage) ? disabledEdit : tableBodyicon} />}
                label={handleValidateCodevalue(internationalise,'COMMON_EDIT')}
                className="textPrimary"
                onClick={handleEditClick(id)}
                color="inherit"
              />,
            ];
          },
        },
        { 
            field: 'name', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_NAME'),
            flex: 1,
            editable: false,
        },
         { 
            field: 'invoiceqty', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_INV_QTY'),
            flex: 1,
            editable: true,
        },
         { 
            field: 'remainingQty', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_REM_QTY'),
            flex: 1,
            editable: false,
        },
        { 
            field: 'unitOfMeasurement', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_UOM'),
            flex: 1,
            editable: true ,
            minWidth : emailWidth,
            valueGetter:({value})=>{
              if(!value){
                return ""
              }
              return handleValidateCodevalue(internationalise,value)
            }
        },
                { 
                    field: 'sellingPrice', 
                    headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_SP'),
                    flex: 1,
                    editable: false 
                },
                { 
                    field: 'discountAmount', 
                    headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_DA'),
                    flex: 1,
                    editable: false 
                },
                { 
                    field: 'primaryDiscount', 
                    headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_PD'),
                    flex: 1,
                    editable: false 
                },
                { 
                    field: 'cGst', 
                    headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_CGST'),
                    flex: 1,
                    editable: false 
                },
                { 
                    field: 'sGst', 
                    headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_SGST'),
                    flex: 1,
                    editable: false 
                },
                { 
                    field: 'surchargeRate', 
                    headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_SURCHARGE'),
                    flex: 1,
                    editable: false 
                },
                { 
                    field: 'totalPrice', 
                    headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_TP'),
                    flex: 1,
                    editable: false 
                },
      ];


      
    const {totalDiscountAmount,subTotal,totalGst,discountAmount,cGstAmount,sGstAmount,surchargeAmount,priceAfterDiscount,finalPrice} = 
    isDialogOpen?.dilaogproductdata.reduce(
  (acc, item) => {
    const sub = Number(item.subTotal || 0);
    const totalDiscountAmount = Number(item.totalDiscountAmount || 0);
    const discount = Number(item.discountAmount || 0);
    const cgst = Number(item.cgstAmount || 0);
    const sgst = Number(item.sgstAmount || 0);
    const surcharge = Number(item.surchargeAmount || 0);

    acc.totalDiscountAmount += totalDiscountAmount;
    acc.subTotal += sub;
    acc.discountAmount += discount;
    acc.cGstAmount += cgst;
    acc.sGstAmount += sgst;
    acc.surchargeAmount += surcharge;

    acc.priceAfterDiscount = acc.subTotal - acc.totalDiscountAmount;
    acc.totalGst = acc.cGstAmount + acc.sGstAmount;
    const totalTax = acc.cGstAmount + acc.sGstAmount + acc.surchargeAmount;
    acc.finalPrice = acc.priceAfterDiscount + totalTax;

    return acc;
  },
  {
   totalDiscountAmount:0,totalGst:0,subTotal: 0,discountAmount: 0,cGstAmount: 0,sGstAmount: 0,surchargeAmount: 0,priceAfterDiscount: 0,finalPrice: 0,
}
);

const handleOpenConfirm =()=>{
    setOpenDialog({
        ...isDialogOpen,
        isConfirm : true
    })
}
const handleSelectCustomer =(event , Customer)=>{
setorderdetail({
  ...orderdetail,
  selectedCustomer : Customer,
  customerId : Customer?.id
})
}

const handleSelectOwner =(e,Owner)=>{
    setorderdetail({
  ...orderdetail,
  selectedOwner : Owner,
  ownerId : Owner?.id
})
}

const salesOrderFormContent = (
    <>
        <StyledFlexEnd>
        </StyledFlexEnd>
        {(!isViewMode && OrderId) && 
                <Box className = "mt-15 mb-10">
               <Button className='edit-primary ' variant="outlined" onClick={!OrderId ? handleCreateOrder : handleUpdateOrder}>{handleValidateCodevalue(internationalise,'COMMON_SAVE')}</Button>
               <Button className='edit-primary btn-space' variant="outlined" onClick={()=>handleUpdateOrder(true)}>{handleValidateCodevalue(internationalise,'COMMON_SAVE_AND_EXIT')}</Button>
                </Box>
               }
        <StyledLeadContainer>
        {OrderId  &&<>
        <TextFiledWithLabel
            name="id"
            disabled="true"
            label={handleValidateCodevalue(internationalise,'SO_EDIT_ORDER_ID')}
            value= {OrderId}
        />
        {orderdetail?.leadId &&
        <TextFiledWithLabel
            name="leadId"
            disabled = {true}
            label={handleValidateCodevalue(internationalise,'SO_EDIT_LEAD_ID')}
            value= {orderdetail?.leadId}
        />
        }
        </>}
            <AutoCompleteComponent
                required={true}
                disabled={isViewMode || !(specificRolePermission?.isAllOrderManage || specificRolePermission?.isOrderTeamManage)}
                optionSet = {ownerlistdropdown}
                value={orderdetail?.selectedOwner|| null}
                error = {orderdetail?.selectedOwner ? false : isRequired}
                name = "ownerId"
                placeholder={handleValidateCodevalue(internationalise,'SO_EDIT_OWNER')}
                label={handleValidateCodevalue(internationalise,'SO_EDIT_OWNER')}
                onChange={(event, Owner) => handleSelectOwner(event, Owner)}
            />
           <SelectBoxWithLabel
            disabled = {OrderId ? isViewMode : true}
            required={OrderId ? true : false}
            isStatic={false}
            ownerdropdown= {false}
            name= "status"
            // error={orderdetail?.status ? false : requiredValue?.status}
            value= {orderdetail?.status ? orderdetail?.status : ''}
            optionMenuItem={SOStatusData}
            label={handleValidateCodevalue(internationalise,'SO_STATUS')}
            handleOnChange={handleChnageOrderdetail}
        />
    {!OrderId  && 
    <>
    <TextFiledWithLabel
    className="sales-order-hidden-field"
    />
    <TextFiledWithLabel
    className="sales-order-hidden-field"
    />
    </>
    }
    {(OrderId && !orderdetail?.leadId) &&
    <TextFiledWithLabel
    className="sales-order-hidden-field"
    />}
        </StyledLeadContainer>
        <StyledLeadContainer>
            <AutoCompleteComponent
            required={true}
            isOwner = {true}
            disabled={isViewMode}
            optionSet = {customerdropdown}
            value={orderdetail?.selectedCustomer|| null}
            error = {orderdetail?.selectedCustomer ? false : isRequired}
            name = "selectedCustomer"
            placeholder={handleValidateCodevalue(internationalise,'SO_EDIT_CUSTOMER')}
            label={handleValidateCodevalue(internationalise,'SO_EDIT_CUSTOMER')}
            onChange={(event, Owner) => handleSelectCustomer(event, Owner,"Customer")}
        />
        {OrderId  && 
    <>
        <TextFiledWithLabel
            name="totalPrice"
            disabled = {true}
            label={handleValidateCodevalue(internationalise,'SO_EDIT_TOTAL_PRICE')}
            value= {orderdetail?.totalOrderPrice || ''}
        />
    <TextFiledWithLabel
    className="sales-order-hidden-field"
    />
    <TextFiledWithLabel
    className="sales-order-hidden-field"
    />
    </>
    }
        </StyledLeadContainer>
    {OrderId &&
    <WhoColumnTextfieds
    entityDetails={orderdetail}
    />}
        <EntityNote
        entityDetails = {orderdetail} 
        onChange = {handleChnageOrderdetail}        
        headingLabel = {handleValidateCodevalue(internationalise,"COMMON_SPECIAL_NOTE")}
        />
    </>
);

    return (
        <BiztantuLoader open={isLoadingProgress} isChildren={true}>
             <Box className='globalBox'>
            {OrderId ? (
                <LeadAccordion
                    label={`${handleValidateCodevalue(internationalise,'SO_EDIT_SO_DETAILS')} - ${OrderId}`}
                    defaultExpanded={true}
                >
                    {salesOrderFormContent}
                </LeadAccordion>
            ) : (
                <>
                    <StyledSubHeader>
                        {handleValidateCodevalue(internationalise,'SO_EDIT_SO_DETAILS')} 
                    </StyledSubHeader>
                    {salesOrderFormContent}
                </>
            )}    
                <LeadProduct
                    isViewMode = {isViewMode}
                    productTypes={productStaticType}
                    isEdit={OrderId ? true : false}
                    getProductDetails = {()=>getSpecificorderdetails(OrderId)}
                    data={orderdetail?.salesOrderProducts}
                    selectedproductData={selectedproductData}
                    isOrderproduct= {true}
                    selectedproduct={selectedproduct}
                    selectedaddedproduct={selectedaddedproduct}
                    productQuantity={productQuantity}
                    handleChangeQuantity={handleChangeQuantity}
                    getDataGridData={(data) => setTableData(data)}
                    handleAddLeadProduct={handleAddOrderProduct}
                    handleUpdateLeadproduct={handleUpdateOrderproduct}
                    handleSelectMultiproduct={handleSelectMultiproduct}
                    handleFilterOption={handleFilterOption}
                    inputprice={inputprice}
                    orderstatus = {orderdetail?.status}
                    handlechangeInputprice={handlechangeInputprice}
                    pricerange={pricerange}
                    handleClearAfterAdded={handleClearAfterAdded}
                    handlegenerateinvoice = {handlegenerateinvoice}
                    setSelectionModel={(data) => setSelectionModel(data)}
                    selectionModel={selectionModel}
                    handleviewinvoices={handleviewproductinvoices} 
                    accordionLabel = {handleValidateCodevalue(internationalise,'SO_EDIT_SO_PROD')}
                
                />
                {OrderId &&
            <Box className="sales-order-invoice-section">
            <LeadAccordion
                label=  {handleValidateCodevalue(internationalise,'SO_EDIT_INV')} 
            >
                <DataGridTable
                    
                    rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                    height={CHILD_DATAGRIDTABLE_HEIGHT}
                    columns = {orderInvoiceColumns}
                    dataGridData = {orderdetail?.invoiceProductDtos}
                    isRequiredToolBar = {false}
                    isCheckboxReq = {true}
                    isLoading={false}
                />
                </LeadAccordion>
                </Box>
                }

                {(specificRolePermission?.isAuditView  && OrderId) && <div>
                    <LeadAccordion
                        label={handleValidateCodevalue(internationalise,'COMMON_AUDIT_LOGS')}
                        expanded={isAuditAccordionExpanded}
                        onChange={handleAuditAccordionChange}
                        TransitionProps={{ unmountOnExit: true }}
                    >
                        <AuditLogs
                            label = ""
                            isSearchRequired = {false}
                            entityDetails = {{
                                entityId: OrderId,
                                entity: "SALES_ORDER_SIDEBAR_MENU"
                            }}
                            module="order"
                        />
                    </LeadAccordion>
                    
                </div>}
            
            </Box>
            <CreateLeadFooter>
               <Stack alignItems="center" display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
               
               <Typography variant='h6'>
                      {OrderId ? `${handleValidateCodevalue(internationalise, 'SO_EDIT_TITLE_EDIT')} - ${OrderId}` : handleValidateCodevalue(internationalise, 'SO_EDIT_TITLE_CREATE')}
                </Typography>
                               
                <Button className='edit-primary btn-space' variant="outlined" onClick={() =>goBack()}>{handleValidateCodevalue(internationalise,'COMMON_BACK')}</Button>
               {/* {
                (specificRolePermission?.isOrderManage&& (orderdetail?.status === salesOrderStatus?.SO_STATUS_OPEN || orderdetail?.status === salesOrderStatus?.SO_STATUS_PARTIALLY_INVOICED) && isViewMode) && <Button  className='edit-primary' variant="outlined" onClick={()=>setIsViewMode(!isViewMode)}>{handleValidateCodevalue(internationalise,'COMMON_EDIT')}</Button>
                } */}
               {(!isViewMode && !OrderId) && 
               <>
               <Button className='edit-primary ' variant="outlined" onClick={!OrderId ? handleCreateOrder : handleUpdateOrder}>{handleValidateCodevalue(internationalise,'COMMON_SAVE')}</Button></>
               }
               </Stack>
            </CreateLeadFooter>
            {
                isDialogOpen?.isOpen && (
                    <LeadDialog 
                        open = {isDialogOpen?.isOpen}
                        handleClose = {() => setOpenDialog({...isDialogOpen, isOpen: false})}
                        title= {handleValidateCodevalue(internationalise,'SO_INV_PROD_TITLE')}
                        size="xl"
                        btnlabel={handleValidateCodevalue(internationalise,'SO_EDIT_SAVE')}
                        selectedowner={true}
                        alternateBtnLabel = {handleValidateCodevalue(internationalise,'SO_EDIT_CANCEL')}
                        handleSave={handleOpenConfirm}
                    >
                        <DataGridTable 
                        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                        height={CHILD_DATAGRIDTABLE_HEIGHT}
                            columns={invoiceGenerateColumns}
                            isViewMode = {isViewMode}
                            dataGridData = {isDialogOpen?.dilaogproductdata}
                            isRequiredToolBar = {false}
                            isCheckboxReq = {false}
                            isInvoiceproduct = {true}
                            rowModesModel={rowModesModel}
                            columnVisibilityModel = {{invoiceqty: true}}
                            handleUpdateProduct={handleUpdateProduct}
                        />
                                        <StyledLeadContainer className="sales-order-subtotal-row">
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                               {handleValidateCodevalue(internationalise,'COMMON_SUB_TOTAL')}
                                            </Typography>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                                ₹{subTotal.toLocaleString('en-IN')}
                                            </Typography>
                                        </StyledLeadContainer>
                                        <StyledLeadContainer>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                               {handleValidateCodevalue(internationalise,'COMMON_TOTAL_DISCOUNT')}
                                            </Typography>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                                ₹{totalDiscountAmount.toLocaleString('en-IN')}
                                            </Typography>
                                        </StyledLeadContainer>
                                        <StyledLeadContainer>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                               {handleValidateCodevalue(internationalise,'COMMON_PRICE_POST_DISCOUNT')}
                                            </Typography>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                                ₹{priceAfterDiscount.toLocaleString('en-IN')}
                                            </Typography>
                                        </StyledLeadContainer>
                                        <StyledLeadContainer>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                               {handleValidateCodevalue(internationalise,'COMMON_CGST')}
                                            </Typography>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                                ₹{cGstAmount.toLocaleString('en-IN')}
                                            </Typography>
                                        </StyledLeadContainer>
                                        <StyledLeadContainer>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                               {handleValidateCodevalue(internationalise,'COMMON_SGST')}
                                            </Typography>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                                ₹{sGstAmount.toLocaleString('en-IN')}
                                            </Typography>
                                        </StyledLeadContainer>
                                        <StyledLeadContainer>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                               {handleValidateCodevalue(internationalise,'COMMON_TOTAL_GST')}
                                            </Typography>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                                ₹{totalGst.toLocaleString('en-IN')}
                                            </Typography>
                                        </StyledLeadContainer>
                                        <StyledLeadContainer>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                               {handleValidateCodevalue(internationalise,'COMMON_TOTAL_SURCHARGE')}
                                            </Typography>
                                            <Typography variant="subtitle1" className="sales-order-summary-regular">
                                                ₹{surchargeAmount.toLocaleString('en-IN')}
                                            </Typography>
                                        </StyledLeadContainer>
                                        <StyledLeadContainer>
                                            <Typography variant="subtitle1" className="sales-order-grand-total-label">
                                               {handleValidateCodevalue(internationalise,'COMMON_GRAND_TOTAL')}
                                            </Typography>
                                            <Typography variant="subtitle1" className="sales-order-grand-total">
                                                ₹{finalPrice.toLocaleString('en-IN')}
                                            </Typography>
                                        </StyledLeadContainer>
                    </LeadDialog>
                )
             }
             { isDialogOpen?.isConfirm && (
                    <LeadDialog 
                        open = {isDialogOpen?.isConfirm}
                        handleClose = {() => setOpenDialog({...isDialogOpen, isConfirm: false})}
                        handleSave={handlecreateinvoice}
                        title= {handleValidateCodevalue(internationalise,'SO_INVOICE_CREATE_TITLE')}
                        size="sm"
                        btnlabel= {handleValidateCodevalue(internationalise,'COMMON_YES')}
                        alternateBtnLabel = {handleValidateCodevalue(internationalise,'COMMON_CANCEL')}
                        >
                            <Typography gutterBottom>
                                {handleValidateCodevalue(internationalise,'INVOICE_CREATE_CONFIRMATION')}
                            </Typography>        
                    </LeadDialog>
                                )
                            }
        </BiztantuLoader>
    )
}

export default CreateEditSalesOrder;

